<template>
  <v-row>
    <v-col cols="12">
      <h1 class="title primary--text mb-4">
        ระบบสร้างบาร์โค้ดอัตโนมัติ
        <span class="ml-4 caption red--text">
          *ระบบจะทำการสร้างบาร์โค้ดให้กับสินค้าที่ยังไม่มีบาร์โค้ดเท่านั้น
        </span>
      </h1>
      <p class="mb-8">
        EAN-8: เลข 8 หลัก, EAN-13: เลข 13 หลัก, CODE-128: ตัวอักษร (ระบบจะใช้รหัสสินค้า/สินค้าย่อยเป็นบาร์โค้ด)
      </p>
      <div>
        <div class="mb-2">
          <label for="barcode-type">
            ประเภทของบาร์โค้ดที่ต้องการสร้าง
          </label>
          <span class="text-error">*</span>
        </div>
        <SelectBarcodeFormat v-model="barcodeFormat" />
      </div>
    </v-col>
    <v-col
      cols="12"
      class="d-flex flex-column flex-sm-row justify-sm-space-between gap-2">
      <div class="d-flex flex-column flex-sm-row align-sm-center">
        <h1 class="title primary--text mr-4">
          เลือกสินค้าที่ต้องการสร้างบาร์โค้ด
        </h1>
        <BarcodeFilter
          :value="filter"
          @onFilter="handleFilter($event)" />
      </div>
      <div class="d-flex">
        <v-text-field
          :value="searchText"
          placeholder="ค้นหาสินค้า"
          append-icon="mdi-magnify"
          dense
          outlined
          hide-details
          @input="setSearchTextDebounce($event)" />
      </div>
    </v-col>
    <v-col
      v-if="productList"
      cols="12">
      <ProductTableBarcode
        v-model="selected"
        :headers="headers"
        :items="productList.nodes"
        :total-pages="productList.pagesCount"
        :loading="$apollo.queries.productList.loading"
        :page="page"
        :per-page="perPage"
        @onPageChange="handlePageChange($event)" />
    </v-col>
    <v-col cols="12">
      <BarcodeCreateDialog
        :item-ids="itemsSelectedIds"
        :barcode-format="barcodeFormat"
        @onSuccess="clearItemsSelected()" />
    </v-col>
  </v-row>
</template>

<script>
import { GET_PRODUCT_LIST_FOR_CREATE_BARCODE } from '@/resources/graphql'
import ProductTableBarcode from '../components/ProductTableBarcode.vue'
import SelectBarcodeFormat from '../components/SelectBarcodeFormat.vue'
import BarcodeCreateDialog from '../components/BarcodeCreateDialog.vue'
import BarcodeFilter from '../components/BarcodeFilter.vue'

export default {
  components: {
    ProductTableBarcode,
    SelectBarcodeFormat,
    BarcodeCreateDialog,
    BarcodeFilter
  },
  apollo: {
    productList: {
      fetchPolicy: 'network-only',
      query: GET_PRODUCT_LIST_FOR_CREATE_BARCODE,
      variables () {
        const filter = {}
        if (this.filter?.shopee) {
          filter.shopee = this.filter?.shopee
        }
        if (this.filter?.lazada) {
          filter.lazada = this.filter?.lazada
        }
        return {
          page: this.page,
          perPage: this.perPage,
          categoryId: this.filter?.categoryId || '',
          brandId: this.filter?.brandId || '',
          stockId: this.filter?.stockId || '',
          search: this.searchText,
          ...filter
        }
      }
    }
  },
  data () {
    return {
      headers: [
        {
          text: 'รหัสสินค้า',
          align: 'start',
          sortable: false,
          value: 'code',
          width: '250px'
        },
        {
          text: 'ชื่อสินค้า',
          align: 'start',
          sortable: false,
          value: 'name'
        },
        {
          text: 'บาร์โค้ด',
          align: 'start',
          sortable: false,
          value: 'barcode',
          width: '300px'
        }
      ],
      selected: [],
      barcodeFormat: '',
      filter: {
        categoryId: [],
        brandId: [],
        stockId: null,
        shopee: false,
        lazada: false
      },
      page: 1,
      perPage: 10,
      totalPages: 0,
      productList: {
        nodes: [],
        nodesCount: 0,
        pagesCount: 0
      },
      searchText: ''
    }
  },
  computed: {
    itemsSelectedIds () {
      return this.selected.map(({ id }) => id)
    }
  },
  created () {
    this.setSearchTextDebounce = this.$_.debounce(this.setSearchText, 800)
  },
  methods: {
    handlePageChange (page) {
      this.page = page
    },
    handleFilter (filter) {
      this.filter = filter
      this.page = 1
    },
    clearItemsSelected () {
      this.$apollo.queries.productList.refetch()
      this.selected = []
    },
    setSearchText (searchText = '') {
      this.searchText = searchText
      this.page = 1
    }
  }
}
</script>

<style lang="scss" scoped>
.barcode-select {
  max-width: 415px;
}
.v-tabs {
  ::v-deep .v-slide-group__content {
    height: 42px;
  }
  ::v-deep .v-tab {
    background-color: #ececec;
    margin-right: 10px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    min-width: 158px;
    font-weight: normal;
    font-size: 14px;
    overflow: hidden;
    border: 1px solid #e7e7e7;
  }
  ::v-deep .v-tab--active {
    background-color: white;
    color: var(--v-primary-base);
    &:before {
      opacity: 0 !important;
    }
  }
}
</style>
